import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { ErrorLoggerService } from './services/error-logger.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(private injector: Injector) {}

  handleError(error: any): void {
    console.error(error);
    const logger = this.injector.get(ErrorLoggerService);
    logger.logError(error);
  }
}
